angular.module('impactx.approval').controller('ApprovalItemCtrl', ['$scope',
    'ColorUtilService',
    '$controller',
    'TranslationService',
    'ProductEuelService',
    function ($scope, ColorUtilService, $controller, TranslationService, ProductEuelService) {
    $controller('ItemCtrl', {$scope: $scope, ColorUtilService: ColorUtilService});

    var self = this;
    $scope.productDataSheetLabel = TranslationService.get("productDataSheet");
    self.productEuelService = ProductEuelService;
    $scope.ctrlRequired = {};
    for(var key in $scope.item.control) {
        $scope.ctrlRequired[key] = $scope.item.control[key].showMust;
    }

    self.requireCtrl = function(ctrlString){
        if($scope.ignoreAccountingRequired){
            $scope.ctrlRequired[ctrlString] = false;
        } else {
            $scope.ctrlRequired[ctrlString] = $scope.requireCtrl({ctrlString: ctrlString, item: $scope.item});
        }
        return $scope.ctrlRequired[ctrlString];
    };
    
    self.showControl = function(ctrl, type){
        return ctrl && ($scope.ctrlRequired[type] || ctrl.set.length>0 || ($scope.showControl && $scope.showControl.value && $scope.item.selected));
    };

    if ($scope.item.infoGroup) {
        var color = ColorUtilService.getColor($scope.item.infoGroup);
        $scope.color = {'border-left-color': color};
    }
    else {
        $scope.color = {'border-left-color': 'transparent'};
    }

    if ($scope.item.selectGroup) {
        var color = ColorUtilService.getColor($scope.item.selectGroup + $scope.offSetForSelectColor);
        $scope.colorSelect = {'border-left-color': color};
    }
    else {
        $scope.colorSelect = {'border-left-color': 'transparent'};
    }

    if ($scope.item.basketMandatoryGroup) {
        var color = ColorUtilService.getColor($scope.item.basketMandatoryGroup + $scope.offSetForBasketMandatoryColor);
        $scope.colorBasketMandatory = {'border-left-color': color};
    }
    else {
        $scope.colorBasketMandatory = {'border-left-color': 'transparent'};
    }

    if ($scope.item.basketItemGroupId) {
        var color = ColorUtilService.getColor($scope.item.basketItemGroupId + $scope.offSetForBasketItemGroupColor);
        $scope.colorBasketItemGroup = {'border-left-color': color};
    }
    else {
        $scope.colorBasketItemGroup = {'border-left-color': 'transparent'};
    }

    $scope.extendBorder = function () {
        var element = document.getElementsByClassName('basket-item-' + $scope.item.infoGroup);
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorder = function () {
        var element = document.getElementsByClassName('basket-item-' + $scope.item.infoGroup);
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    $scope.extendBorderSelect = function() {
        var element = document.getElementsByClassName('basket-item-' + ($scope.item.selectGroup + $scope.offSetForSelectColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function(aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorderSelect = function() {
        var element = document.getElementsByClassName('basket-item-' + ($scope.item.selectGroup + $scope.offSetForSelectColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function(aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    $scope.extendBorderBasketMandatory = function() {
        var element = document.getElementsByClassName('basket-item-' + ($scope.item.basketMandatoryGroup + $scope.offSetForBasketMandatoryColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function(aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorderBasketMandatory = function() {
        var element = document.getElementsByClassName('basket-item-' + ($scope.item.basketMandatoryGroup + $scope.offSetForBasketMandatoryColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function(aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    $scope.extendBorderBasketItemGroup = function () {
        var element = document.getElementsByClassName('basket-item-group-' + ($scope.item.basketItemGroupId + $scope.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorderBasketItemGroup = function () {
        var element = document.getElementsByClassName('basket-item-group' + ($scope.item.basketItemGroupId + $scope.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };
}]);
